import { Component, Injector, Input, Optional } from '@angular/core';

import { RelatieUserService } from 'src/app/core/service/relatie-user.service';
import { RelatieUser } from 'src/app/core/dto/relatie-user';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType, getPartialled } from '@mango/core';
import { User } from 'src/app/user/user';

@Component({
    selector: 'c-i-j-borculo-relatie-user-collection',
    templateUrl: './relatie-user-collection.component.html'/*,
    styleUrls: ['./relatie-user-collection.component.css'] */
})
export class RelatieUserCollectionComponent extends PagedCollectionComponent<RelatieUser> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<RelatieUser>([
        { colDef: 'nummer', prop: x => x.relatie.oldID, searchable: SearchableType.Number },
        { colDef: 'relatie', prop: x => x.relatie.naam1, searchable: SearchableType.String }		
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    private userID: User;

    constructor(public service: RelatieUserService, @Optional() protected filter: Filter<RelatieUser>, injector: Injector) {
        super('/relatieUser/relatieUser', injector, RelatieUser);

        this.initInput('user', this.filterBuilder.equal(x => x.user.id));

        this.filter.onGetChipLabel(x => x.relatie.naam1, () => 'Relatie');
		
    }
        
    @Input() set user(val: User) { this.handleInput('user', val.id); this.userID = val;}

}